import { RESERVED, ACTIVE, BLOCKED, TRIAL, CLOSED, FREEZE, CLOSURE } from '@/models/Profile'

export const STATUS_LABELS = {
  [RESERVED]: 'Reserved',
  [ACTIVE]: 'Active',
  [BLOCKED]: 'Blocked',
  [TRIAL]: 'Trial',
  [CLOSED]: 'Closed',
  [FREEZE]: 'Freeze',
  [CLOSURE]: 'Closure'
}

export default (status) => {
  return STATUS_LABELS[status] || ''
}
